import GeneralService from "@/views/services/general.service.js";

export default {
    namespaced: true,
    state: {
        S_NOTIFICATIONS: [],
        S_NOTIFICATIONS_COUNT: 0,
    },
    getters: {
        G_NOTIFICATIONS: (state) => state.S_NOTIFICATIONS,
        G_NOTIFICATIONS_COUNT: (state) => state.S_NOTIFICATIONS_COUNT,
    },
    mutations: {
        M_NOTIFICATIONS(state, payload) {
            state.S_NOTIFICATIONS = payload;
        },
        M_NOTIFICATIONS_COUNT(state, payload) {
            state.S_NOTIFICATIONS_COUNT = payload;
        },
    },
    actions: {
        async A_GET_NOTIFICATIONS({ commit }, payload) {
            try {
                const employeeId = JSON.parse(localStorage.getItem("userData")).employee_id;
                const { data } = await GeneralService.getNotifications({ user_id: employeeId });
                commit("M_NOTIFICATIONS", data);
                if (data.length > 0) {
                    commit("M_NOTIFICATIONS_COUNT", data[0].total ?? 0);
                }
            } catch (error) {
                throw error;
            }
        },

    },
};
